import React, { useState, useEffect, useRef } from 'react';
import './searchGeneral.scss';
import { Link } from 'react-router-dom';
import { SearchGeneralProps } from './SearchGeneral.interface';
import { svg_default_file_app } from '../../../../core/hooks/assetsConstants';
import { textConvertUrl, getDynamicProperty } from '../../../../core/hooks/textConvert';
import InputGeneral from '../../../content/inputs/input_general/InputGeneral';

export default function SearchGeneral({ data = [], onRedirect, onClick, showInitialResults = false }: SearchGeneralProps) {

    const [dataDictionary, setDataDictionary] = useState<any[]>(data);
    
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredServices, setFilteredServices] = useState<any[]>([]);
    const [isContentVisible, setIsContentVisible] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setDataDictionary(Array.isArray(data) ? data : []);
        setFilteredServices(Array.isArray(data) ? data.slice(0, 5) : []);
    }, [data]);

    const handleInputFocus = () => {
        if (searchTerm || showInitialResults) {
            setIsContentVisible(true);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsContentVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setSearchTerm(value);
        setIsContentVisible(true);

        const filtered = dataDictionary.filter((service: any) =>
            (getDynamicProperty(service, 'name') && getDynamicProperty(service, 'name').toLowerCase().includes(value.toLowerCase()))
        );
        setFilteredServices(filtered);
    };

    const handleLinkClick = () => {
        setIsContentVisible(false); // Oculta la lista
        if (onRedirect) onRedirect(); // Llama a la función `onRedirect` si existe
    };

    return (
        <section className="content_serach_general">
            <div className="content" ref={containerRef}>
                <div className="search">
                    <InputGeneral
                        nameClass="input"
                        type="text"
                        placeholder="Buscar en el diccionario..."
                        icon="fa-regular fa-search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onFocus={handleInputFocus}
                    />
                </div>

                {isContentVisible && (
                    <div className="content_services scroll_element">
                        <div className='services'>
                            {filteredServices.map((element: any, index: any) => (
                                <Link
                                    onClick={handleLinkClick}
                                    to={`/a/${textConvertUrl(getDynamicProperty(element, 'slug'))}/${getDynamicProperty(element, 'id')}`}
                                    key={index}
                                    className="service_item"
                                >
                                    <div className='image'>
                                        <img src={svg_default_file_app} width={30} alt={getDynamicProperty(element, 'name')} />
                                    </div>

                                    <div className='info'>
                                        <h2 className='title'>{getDynamicProperty(element, 'name')}</h2>
                                    </div>
                                </Link>
                            ))}

                            {filteredServices.length === 0 && (
                                <div>
                                    <p>No se encontró resultados</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
